import React,{useEffect, useState} from 'react'
import {Container, Row, Col, Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getCrops, removeCrop } from '../../../actions/cropsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Crops() { 
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true) 
    const {crops, loading, result} = useSelector(state=>state.crops) 
    const dispatch = useDispatch()
    
    useEffect(()=>{
        dispatch(getCrops())
    }, [dispatch])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])  

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('crops.itsok'),
                    icon: 'error',
                    text: t('crops.'+result.message+'0') + result.count + t('crops.'+result.message+'1')
                })
                dispatch({
                    type: 'CROP_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('crops.letsok'),
                    icon: 'success',
                    text: t('crops.deletedcrop')
                })
                dispatch({
                    type: 'CROP_RESET_RESULT'
                })
            }
        }
    }, [result, dispatch, t])

    const deleteCrop = (idCrop) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeCrop(idCrop))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    // Datatables
    const columns = [
        {
            name: t('crops.name'),
            cell: datos =>
                <div>
                    {datos.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('crops.description'),
            cell: datos =>
                <div>
                    {datos.description}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: '',
            cell: datos =>
            <>
                <Button variant="outline-info mx-auto" href={`/admin/crop/`+datos._id}>
                    <i className="fas fa-crop"></i> <i className="fas fa-edit fa-sm"></i>
                </Button>
                <Button variant="outline-danger mx-auto" onClick={() => deleteCrop(datos._id)}>
                    <i className="fas fa-crop"></i> <i className="fas fa-minus fa-sm"></i>
                </Button>
            </>
        }
    ]
      
    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>        
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('crops.editcrop')}</h1> 
                        <label className='mb-2'>{t('crops.selectcrop')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/crop`}>
                                <i className="fas fa-crop"></i> {t('crops.new')}
                            </Button>
                        </Row>
                        <Row className="text-center justify-content-center">
                            {crops 
                                ?
                                    <CustomDataTable columns={columns} data={crops} />
                                :
                                    <></>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}